import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

import "./cellButton.css";

export class CellButton extends PureComponent {
  render() {
    const { children, className, type, icon, disabled, onClick, ...others } = this.props;
    const typeStr = type || "default";
    const cls = classNames({
      "weui-btn_cell": true,
      [`weui-btn_cell-${typeStr}`]: true,
      "weui-btn_cell__disabled": disabled
    }, className);

    const handleClick = e => {
      if (disabled) {
        e.preventDefault();
      } else {
        if (typeof onClick === "function") {
          onClick(e);
        }
      }
    };

    return (
      <a role="button" tabIndex={ 0 } className={ cls } onClick={ handleClick } onKeyDown={ handleClick } { ...others }>
        {
          icon && <img className="weui-btn_cell__icon" src={ icon } alt="" />
        }
        { children }
      </a>
    );
  }
}
